import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import ElementUI from 'element-ui';
import "@/directive";

import ListPage from '@/components/ListPage';

import 'element-ui/lib/theme-chalk/index.css';
import './assets/styles/index.less';
import './assets/styles/tailwind.css';

Vue.prototype.bus = new Vue();

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.component('ListPage', ListPage);

window.vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
